import {
	readLocalStorage,
	writeLocalStorage,
	resetLocalStorage,
} from "./localStorageUtils";
import { SAVEDWORDS_KEYNAME, DEFAULTWORDS_COOKIENAME } from "@/common/consts";
import { isEmpty } from "@/common/functions/objectUtils";

/**
 * Return the spoken name of a given number
 */
export const number2Word = (number) => {
	const names = [
		"Zero",
		"One",
		"Two",
		"Three",
		"Four",
		"Five",
		"Six",
		"Seven",
		"Eight",
		"Nine",
		"Ten",
		"Eleven",
		"Twelve",
	];
	return typeof names[number] !== "undefined" ? names[number] : number;
};

/**
 * Pluralize filter
 */
export const pluralize = (value, word) => (value == 1 ? word : `${word}s`);

/**
 * Get an Array of the alphabet. Sing along with me!
 */
export const getLetterArray = () => {
	return "abcdefghijklmnopqrstuvwxyz".split("");
};

export const getLengthsArray = (len, first = 0) => {
	return Array.from({ length: len }, (v, i) => i + first);
};

/**
 * Uppercase the first letter of a string
 *
 * @param {string} string The string to uppercase
 * @return {string} The string with an uppercase first letter
 */
export const upperCaseFirst = (string) => {
	return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
};

/**
 *  Highlight letter when used space or ? in search
 *
 * @param {string} word returned by WF API
 * @param {string} tiles anagram
 * @return {string} the word string, with wildcard-replaced letters wrapped in <span></span>
 */
export const highlightWildcards = (word, tiles) => {
	if (!tiles) return word;

	const unaccentedChar = (letter) => {
		if (letter === "á") return "a";
		if (letter === "é") return "e";
		if (letter === "í") return "i";
		if (letter === "ó") return "o";
		if (letter === "ú" || letter === "ü") return "u";
		return letter;
	};

	const w = word.toLowerCase().split("");
	const ws = w.map((l) => unaccentedChar(l));
	const ts = tiles
		.toLowerCase()
		.split("")
		.map((l) => unaccentedChar(l));
	const o = [];

	ws.forEach((l, wi) => {
		// Find the first position of this letter among the tiles.
		let ti = ts.indexOf(l);

		if (ti >= 0) {
			// Letter exists among the tiles.
			o.push(w[wi]);
		} else {
			// Letter doesn't exist. Find the position of the wildcard.
			ti = ts.indexOf("?");
			o.push(`<span class="highlighted">${w[wi]}</span>`);
		}

		// Remove the letter (or wildcard) from the tiles.
		ts.splice(ti, 1);
	});

	// Rejoin it into a string, and remove redundant neighbouring tags.
	return o.join("").replace('</span><span class="highlighted">', "");
};

export const writeSavedWords = (savedWords) => {
	if (isEmpty(savedWords)) {
		resetLocalStorage(SAVEDWORDS_KEYNAME);
		return;
	}
	savedWords.forEach((item) => {
		item.date = new Date(
			item.timestamp == undefined ? item.date : item.timestamp
		).getTime();
	});
	writeLocalStorage(SAVEDWORDS_KEYNAME, savedWords);
};

export const readSavedWords = () => {
	const stub = [];
	return navigator.cookieEnabled
		? readLocalStorage(SAVEDWORDS_KEYNAME)
		: stub;
};

export const getDefaultWordsRemoved = (vm) => {
	return vm.$cookies.get(DEFAULTWORDS_COOKIENAME);
};

export const setDefaultWordsRemoved = (vm, value) => {
	vm.$cookies.set(DEFAULTWORDS_COOKIENAME, value, -1, null);
};

/**
 *  Replace (accents or special) Characters from a string
 *
 * @param {string} str the word string that contains (accents or special) Characters
 * @return {string} the word string, replaced (accents or special) Characters with normal Characters
 */
export const replaceAccentChars = (str) => {
	return str
		.replace(/á/gi, "a")
		.replace(/é/gi, "e")
		.replace(/í/gi, "i")
		.replace(/ó/gi, "o")
		.replace(/[úü]/gi, "u");
};
